<template>
    <section class="gmp-section gmp-mb-l">
        <div class="hero-landing">
            <div class="hero-landing__background hero-landing__overview">
                <div class="gmp-banner gmp-overview-hero">
                    <picture>
                        <img class="gmp-no-grab hero-landing__image" src="@/assets/img/home.png"
                             alt="Meaningful insights.<br>Smarter marketing.<br>Better results.">
                    </picture>
                </div>
            </div>
            <div class="hero-landing__content">
                <div class="h-c-page">
                    <div class="h-c-grid">
                        <div class="h-c-grid__col h-c-grid__col--12 h-c-grid__col--align-middle">
                            <h1 class="h-c-headline h-c-headline--display-two h-has-bottom-margin">
                                全流程覆盖，餐饮供应链的全面升级
                            </h1>
                            <h2 class="h-c-headline h-c-headline--four">
                                从需求发起到最终管理的全流程覆盖，打通了采购、配送、库存、中央厨房和总部管理之间的所有环节
                            </h2>
                            <a href="/" class="h-c-button h-c-button--primary">
                                <div class="gmp-link__content gmp-link__content--cta-btn">
                                    <span>开始了解</span>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: "HeroLanding"
    }
</script>

<style lang="less">



</style>